import React from "react";

const ExclamationCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g fill="currentColor">
      <path d="M9 16.875a7.875 7.875 0 1 1 0-15.75 7.875 7.875 0 0 1 0 15.75ZM9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z" />
      <path d="M7.877 12.375a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.987 5.62a1.018 1.018 0 1 1 2.026 0l-.395 3.945a.622.622 0 0 1-1.236 0L7.987 5.62Z" />
    </g>
  </svg>
);

export default ExclamationCircleIcon;
